import actions from "~/shared/actions";
import type { DokumenterDto } from "~/shared/api/server";
import type { Action } from "~/utils/actions";

type MimeType = "HTML" | "PDF";

type Fagsystem = "F2100" | "NJORD" | "PIP" | "GABLER" | "ONBASE" | "ENGANGSUTSENDELSE" | "INTERACTIVE" | "UNKNOWN";

export interface Dokument {
	id: string;
	categoryName: string;
	name: string;
	receivedDate: number;
	read: boolean;
	policyNumbers: string[];
	fagsystem: Fagsystem;
	sensitive: boolean;
	mimeType: MimeType;
}

export interface SaveScrollPosition {
	scrollPos: number;
	antallVisteDokumenter: number;
	filterUleste: boolean;
}

export interface DokumentState {
	saveScrollPos?: SaveScrollPosition;
	list: Dokument[];
}

function sortDokumentList(dokumenter: Dokument[]) {
	return dokumenter.sort((a, b) => {
		if (a.receivedDate === b.receivedDate) {
			return a.id > b.id ? -1 : 1;
		}
		return a.receivedDate > b.receivedDate ? -1 : 1;
	});
}

function combinerDokumenter(nyeDokumenter: Dokument[] = [], gamleDokumenter: Dokument[]) {
	return [...nyeDokumenter.filter((nyDok) => !gamleDokumenter.some((gammelDok) => gammelDok.id === nyDok.id)), ...gamleDokumenter];
}

function receiveDokumenter(state: DokumentState, { dokumenter }: DokumenterDto): DokumentState {
	return {
		...state,
		list: sortDokumentList(combinerDokumenter(dokumenter, state.list)),
	};
}

function setLest(state: DokumentState, id: string): DokumentState {
	const list = state.list.map((dok) => {
		if (dok.id !== id) {
			return dok;
		}
		return { ...dok, read: true };
	});
	return { ...state, list };
}

function saveScroll(state: DokumentState, saveScrollPos: SaveScrollPosition) {
	return {
		...state,
		saveScrollPos,
	};
}

export const defaultState: DokumentState = {
	list: [],
};

export default function documents(state = defaultState, action: Action): DokumentState {
	switch (action.type) {
		case actions.DOKUMENTER_NYE_RESPONSE:
			return receiveDokumenter(state, action.data);
		case actions.DOKUMENTER_GAMLE_RESPONSE:
			return receiveDokumenter(state, action.data);
		case actions.SET_LEST:
			return setLest(state, action.data);
		case actions.DOKUMENTER_SAVE_SCROLL:
			return saveScroll(state, action.data);
		case actions.DOKUMENTER_DELETE_SCROLL:
			return { ...state, saveScrollPos: undefined };
		default:
			return state;
	}
}
